import React, { Component } from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ReactStars from "react-rating-stars-component";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { postreviews } from "../../../actions";
import store from "../../../store";
import image from "../../../assets/images/profile.png";
import "./details.scss";

/* ── 4 Luxury Feature Badge Icons (Designer Spec) ── */
const IconRosette = () => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2.5a2.5 2.5 0 0 1 2.5 2.5v1.2a2.5 2.5 0 0 1-5 0V5a2.5 2.5 0 0 1 2.5-2.5z" />
    <path d="M12 21.5a2.5 2.5 0 0 1-2.5-2.5v-1.2a2.5 2.5 0 0 1 5 0V19a2.5 2.5 0 0 1-2.5 2.5z" />
    <path d="M2.5 12a2.5 2.5 0 0 1 2.5-2.5h1.2a2.5 2.5 0 0 1 0 5H5a2.5 2.5 0 0 1-2.5-2.5z" />
    <path d="M21.5 12a2.5 2.5 0 0 1-2.5 2.5h-1.2a2.5 2.5 0 0 1 0-5H19a2.5 2.5 0 0 1 2.5 2.5z" />
    <path d="M5.28 5.28a2.5 2.5 0 0 1 3.54 0l.85.85a2.5 2.5 0 0 1-3.54 3.54l-.85-.85a2.5 2.5 0 0 1 0-3.54z" />
    <path d="M18.72 18.72a2.5 2.5 0 0 1-3.54 0l-.85-.85a2.5 2.5 0 0 1 3.54-3.54l.85.85a2.5 2.5 0 0 1 0 3.54z" />
    <path d="M5.28 18.72a2.5 2.5 0 0 1 0-3.54l.85-.85a2.5 2.5 0 0 1 3.54 3.54l-.85.85a2.5 2.5 0 0 1-3.54 0z" />
    <path d="M18.72 5.28a2.5 2.5 0 0 1 0 3.54l-.85.85a2.5 2.5 0 0 1-3.54-3.54l.85-.85a2.5 2.5 0 0 1 3.54 0z" />
  </svg>
);

const IconInfinity = () => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18.178 8c5.096 0 5.096 8 0 8-3.058 0-4.586-2.5-6.178-5-1.592-2.5-3.12-5-6.178-5-5.096 0-5.096 8 0 8 3.058 0 4.586-2.5 6.178-5 1.592-2.5 3.12-5 6.178-5z" />
  </svg>
);

const IconFeather = () => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20.24 3.76a6 6 0 0 0-8.49 0L3.5 12.01a4 4 0 0 0-.82 4.41L2 22l5.58-.68a4 4 0 0 0 4.41-.82l8.25-8.25a6 6 0 0 0 0-8.49z" />
    <line x1="16" y1="8" x2="2" y2="22" />
    <line x1="17.5" y1="15" x2="9" y2="15" />
  </svg>
);

const IconOccasion = () => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 18h18l-2-9-4.5 4L12 4 9.5 13 5 9l-2 9z" />
    <circle cx="3" cy="7" r="1" fill="#F5B96D" />
    <circle cx="12" cy="3" r="1" fill="#F5B96D" />
    <circle cx="21" cy="7" r="1" fill="#F5B96D" />
    <path d="M4 18h16v1.5H4z" fill="#F5B96D" />
  </svg>
);

class DetailsTopTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: "",
      title: "",
      comment: "",
    };
  }

  render() {
    const { review, item } = this.props;
    const percentage =
      item?.api?.reviews?.percentage && item.api.reviews.percentage !== 0
        ? Object.entries(JSON.parse(item.api.reviews.percentage))
        : [];

    const totalReviews =
      (review && review.length) ||
      (item && item.api && item.api.reviews && item.api.reviews.total) ||
      0;

    const ratingChanged = (newRating) => {
      this.setState({ rating: newRating });
    };

    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2,
      initialSlide: 0,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const notify = () => {
      toast.success("Review Submitted", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        bodyClassName: "toastStyle",
      });
    };

    const SubmitReviews = (e) => {
      e.preventDefault();
      var data = {
        rating: this.state.rating,
        title: this.state.title,
        comment: this.state.comment,
        product_id: item.api.id,
      };
      this.setState({
        rating: "",
        title: "",
        comment: "",
      });
      notify();
      store.dispatch(postreviews(data));
    };

    return (
      <section className="pd-details-tabs-section">
        <Tabs className="pd-details-tabs" defaultIndex={0}>
          {/* ── Left-Aligned Minimal Tab Header ── */}
          <TabList className="pd-tab-list">
            <Tab className="pd-tab-item" selectedClassName="pd-tab-item--active">
              <span className="pd-tab-label">DETAILS</span>
              <div className="pd-tab-indicator" />
            </Tab>
            <Tab className="pd-tab-item" selectedClassName="pd-tab-item--active">
              <span className="pd-tab-label">REVIEWS ({totalReviews})</span>
              <div className="pd-tab-indicator" />
            </Tab>
            {item && item.features ? (
              <Tab className="pd-tab-item" selectedClassName="pd-tab-item--active">
                <span className="pd-tab-label">FEATURES</span>
                <div className="pd-tab-indicator" />
              </Tab>
            ) : null}
            {localStorage.getItem("customerData") ? (
              <Tab className="pd-tab-item" selectedClassName="pd-tab-item--active">
                <span className="pd-tab-label">WRITE REVIEW</span>
                <div className="pd-tab-indicator" />
              </Tab>
            ) : null}
          </TabList>

          {/* ══════════════════════════════════════════
              TAB 1: PRODUCT DETAILS
              ══════════════════════════════════════════ */}
          <TabPanel className="pd-tab-panel">
            <div className="pd-details-container">
              <div className="pd-details-header-row">
                <h3 className="pd-details-heading">Product Details</h3>
                {(item?.api?.sku || item?.sku) && (
                  <span className="pd-sku-badge" title="Product SKU">
                    <span className="pd-sku-label">SKU:</span>
                    <span className="pd-sku-code">{item?.api?.sku || item?.sku}</span>
                  </span>
                )}
              </div>
              <div
                className="pd-details-text"
                dangerouslySetInnerHTML={{
                  __html: item && item.description,
                }}
              />

              {/* 4 Feature Highlights Badges Row (Designer Spec) */}
              <div className="pd-feature-badges">
                <div className="pd-badge-card">
                  <div className="pd-badge-icon">
                    <IconRosette />
                  </div>
                  <div className="pd-badge-text">
                    <span>Premium Quality</span>
                    <span>Materials</span>
                  </div>
                </div>

                <div className="pd-badge-card">
                  <div className="pd-badge-icon">
                    <IconInfinity />
                  </div>
                  <div className="pd-badge-text">
                    <span>Elegant &amp;</span>
                    <span>Stylish Design</span>
                  </div>
                </div>

                <div className="pd-badge-card">
                  <div className="pd-badge-icon">
                    <IconFeather />
                  </div>
                  <div className="pd-badge-text">
                    <span>Lightweight &amp;</span>
                    <span>Comfortable</span>
                  </div>
                </div>

                <div className="pd-badge-card">
                  <div className="pd-badge-icon">
                    <IconOccasion />
                  </div>
                  <div className="pd-badge-text">
                    <span>Perfect for All</span>
                    <span>Occasions</span>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          {/* ══════════════════════════════════════════
              TAB 2: REVIEWS
              ══════════════════════════════════════════ */}
          <TabPanel className="pd-tab-panel">
            <div className="pd-reviews-panel-wrap mt-4 row">
              <div className="col-lg-4 col-md-5 mb-4">
                <div className="reviews-summary-card">
                  <h4
                    className="reviews__heading"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    Customer reviews
                  </h4>
                  <div className="reviews__average-ratings">
                    <div className="average-ratings__stars">
                      <ReactStars
                        count={5}
                        size={22}
                        isHalf={true}
                        value={item && item.api && item.api.reviews.average_rating}
                        edit={false}
                        emptyIcon={<i className="far fa-star"></i>}
                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                        fullIcon={<i className="fa fa-star"></i>}
                        activeColor="#F5B96D"
                      />
                      <span className="stars__average-rating-score px-2">
                        {item && item.api && item.api.reviews.average_rating} /{" "}
                        {item &&
                        item.api &&
                        item.api.reviews.average_rating === 0
                          ? "0.0"
                          : "5.0"}
                      </span>
                    </div>
                  </div>

                  <div className="reviews__breakdown">
                    <div className="reviews-breakdown__wrapper">
                      {[5, 4, 3, 2, 1].map((star, idx) => {
                        const pctIdx = star - 1;
                        const pct =
                          percentage[pctIdx] && percentage[pctIdx][1]
                            ? percentage[pctIdx][1]
                            : 0;
                        return (
                          <div key={star} className="reviews__single-star-average">
                            <div className="single-star-average__amount">
                              {star} star
                            </div>
                            <div className="single-star-average__progress-bar">
                              <progress
                                className="progress-bar__data"
                                max="100"
                                value={pct}
                              ></progress>
                            </div>
                            <div className="single-star-average__percentage">
                              {pct}%
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-8 col-md-7">
                <span className="pd-reviews-list-title">
                  Customer Reviews ({totalReviews}):
                </span>
                <Slider {...settings} className="pd-reviews-slider mt-3">
                  {review && review.length !== 0 ? (
                    review.map((e, i) => (
                      <div key={i} className="pd-review-slide">
                        <article className="pd-review-card">
                          <div className="pd-review-header">
                            <LazyLoadImage
                              src={e.customer?.profile || image}
                              alt={e.name || "User"}
                              height="44px"
                              width="44px"
                              className="pd-review-avatar"
                            />
                            <div className="pd-review-user-info">
                              <div className="pd-review-name">{e.name}</div>
                              <p className="pd-review-email">
                                {e.customer?.email}
                              </p>
                            </div>
                          </div>
                          <div className="pd-review-stars mt-2">
                            <ReactStars
                              count={5}
                              size={18}
                              isHalf={true}
                              value={e.rating}
                              edit={false}
                              activeColor="#F5B96D"
                            />
                          </div>
                          {e.title && (
                            <h5 className="pd-review-title mt-2">{e.title}</h5>
                          )}
                          <p className="pd-review-comment mt-2">{e.comment}</p>
                        </article>
                      </div>
                    ))
                  ) : (
                    <div className="pd-no-reviews-box">
                      <p>No Reviews Yet</p>
                      <span>Be the first to review this product!</span>
                    </div>
                  )}
                </Slider>
              </div>
            </div>
          </TabPanel>

          {/* ══════════════════════════════════════════
              TAB 3: FEATURES (Optional)
              ══════════════════════════════════════════ */}
          {item && item.features ? (
            <TabPanel className="pd-tab-panel">
              <div className="pd-details-container">
                <h3 className="pd-details-heading">Features</h3>
                <p className="pd-details-text">{item.features}</p>
              </div>
            </TabPanel>
          ) : null}

          {/* ══════════════════════════════════════════
              TAB 4: WRITE REVIEW (Optional)
              ══════════════════════════════════════════ */}
          {localStorage.getItem("customerData") ? (
            <TabPanel className="pd-tab-panel">
              <form className="pd-write-review-form mt-4">
                <div className="form-group mb-3">
                  <label className="pd-form-label">Rating:</label>
                  <ReactStars
                    count={5}
                    onChange={ratingChanged}
                    size={24}
                    value={this.state.rating}
                    activeColor="#F5B96D"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="pd-form-label" htmlFor="review-title">
                    Review Title
                  </label>
                  <input
                    type="text"
                    className="form-control cp-input"
                    value={this.state.title}
                    id="review-title"
                    onChange={(e) => this.setState({ title: e.target.value })}
                    placeholder="Enter review subject"
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="pd-form-label" htmlFor="review-comment">
                    Review Comments
                  </label>
                  <textarea
                    className="form-control cp-input cp-textarea"
                    value={this.state.comment}
                    onChange={(e) => this.setState({ comment: e.target.value })}
                    placeholder="Write your testimonial here"
                    id="review-comment"
                    rows="5"
                  />
                </div>
                <button
                  disabled={
                    !this.state.rating ||
                    !this.state.title ||
                    !this.state.comment
                  }
                  className="btn cp-submit-btn"
                  type="submit"
                  onClick={(e) => SubmitReviews(e)}
                >
                  Submit Review
                </button>
              </form>
            </TabPanel>
          ) : null}
        </Tabs>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  review: state.data?.reviewsdata?.data,
});

export default connect(mapStateToProps)(DetailsTopTabs);
